import { Title } from './styles'

export function AlertTitle({ children, variant = "default", ...rest }) {
  return <Title variant={variant} {...rest}>{children}</Title>
}
